import { useState } from 'react';
import { saveQuestionRating } from '../../api/questionAPIs';
import Rating from '@mui/material/Rating';

const MessageRating = ({id}) => {

    const [value, setValue] = useState(0);

    const handleChange = (newValue) => {
        saveQuestionRating(id, newValue);
        setValue(newValue); 
    }

    return (
        <Rating 
            name="no-value" 
            value={value} 
            onChange={(event, newValue) => handleChange(newValue)} 
        />
    )
}

export default MessageRating;
